import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { AgeGate } from "@/components/AgeGate";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

const TITLES = {
  "/": "Hema Connoisseur Collections — Curating Global Taste for India",
  "/about": "About — Hema Connoisseur Collections",
  "/portfolio": "Alcoholic Portfolio — Hema Connoisseur Collections",
  "/distribution": "Distribution — Hema Connoisseur Collections",
  "/infrastructure": "Infrastructure — Hema Connoisseur Collections",
  "/non-alcoholic-fmcg": "Non-Alcoholic & FMCG — Hema Connoisseur Collections",
  "/partner": "Partner With Us — Hema Connoisseur Collections",
  "/contact": "Contact — Hema Connoisseur Collections",
};

export const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title =
      TITLES[pathname] ||
      (pathname.startsWith("/legal/")
        ? "Legal — Hema Connoisseur Collections"
        : "Hema Connoisseur Collections");
  }, [pathname]);

  return (
    <MotionConfig reducedMotion="user">
      <AgeGate />
      <SiteHeader variant={pathname === "/" ? "dark" : "light"} />
      <main>{children}</main>
      <SiteFooter />
    </MotionConfig>
  );
};
